import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../../../../commonComponents/translate';
import * as Utils from '../../../../../../services/utilityFunctions';

class CreditCardItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expMonth: props.exp_month,
      expYear: props.exp_year,
      logo: '',
    };

    switch (props.brand) {
      case 'Visa':
        this.state.logo =
          'https://s3.eu-central-1.amazonaws.com/apperitivo/cards/visa.png';
        break;
      case 'American Express':
        this.state.logo =
          'https://s3.eu-central-1.amazonaws.com/apperitivo/cards/amex.png';
        break;
      case 'MasterCard':
        this.state.logo =
          'https://s3.eu-central-1.amazonaws.com/apperitivo/cards/mastercard.png';
        break;
      case 'Discover':
        this.state.logo =
          'https://s3.eu-central-1.amazonaws.com/apperitivo/cards/discover.png';
        break;
      case 'JCB':
        this.state.logo =
          'https://s3.eu-central-1.amazonaws.com/apperitivo/cards/jcb.png';
        break;
      case 'Diners Club':
        this.state.logo =
          'https://s3.eu-central-1.amazonaws.com/apperitivo/cards/diners.png';
        break;
      default:
        this.state.logo =
          'https://s3.eu-central-1.amazonaws.com/apperitivo/cards/unknow.png';
    }

    this.handleSelect = this.handleSelect.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleSelect() {
    this.props.onSelect(this.props.id);
  }

  handleRemove() {
    this.props.onRemove(this.props.id);
  }

  render() {
    const { t, last4, brand, displayRemove, isSelected, readOnly } = this.props;
    const { expMonth, expYear, logo } = this.state;

    let isExpired = false;
    const today = new Date();
    const thisYear = today.getFullYear();
    const thisMonth = today.getMonth() + 1;
    if (expYear < thisYear) {
      isExpired = true;
    } else if (expYear === thisYear && expMonth < thisMonth) {
      isExpired = true;
    }

    const radioClasses = cx('m-radio', {
      'm-radio--disabled': isExpired,
      'm-radio--state-dynamic': !isExpired,
    });

    const expireTextStyle = isExpired
      ? { color: Utils.colors('danger'), fontWeight: 400 }
      : {};

    const cardNumber = Utils.displayCardNumber(last4);

    return (
      <div className="m-card_item">
        {displayRemove && (
          <button
            className="m-card_item__close"
            type="button"
            onClick={this.handleRemove}
          >
            <i className="la la-close" />
          </button>
        )}
        <label
          htmlFor="cardSelector"
          onClick={isExpired ? () => null : this.handleSelect}
        >
          <span className="m-card_item__control">
            <span className={radioClasses}>
              <input
                id="cardSelected"
                type="radio"
                name="cardSelected"
                checked={isSelected}
                onChange={this.handleSelect}
                readOnly={readOnly}
                disabled={isExpired}
              />
              <span />
            </span>
          </span>
          <span className="m-card_item__label">
            <span className="m-card_item__head">
              <span className="m-card_item__title">{cardNumber}</span>
            </span>
            <span className="m-card_item__body">
              <span style={expireTextStyle}>
                {isExpired
                  ? t('expired')
                  : `${t('expires_at')} ${expMonth}/${expYear}`}
              </span>
              <img className="pull-right" src={logo} alt={brand} />
            </span>
          </span>
        </label>
      </div>
    );
  }
}

CreditCardItem.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  last4: PropTypes.string.isRequired,
  exp_month: PropTypes.number.isRequired,
  exp_year: PropTypes.number.isRequired,
  brand: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  displayRemove: PropTypes.bool,
  readOnly: PropTypes.bool,
  onSelect: PropTypes.func,
  onRemove: PropTypes.func,
};

CreditCardItem.defaultProps = {
  isSelected: false,
  displayRemove: true,
  readOnly: true,
  onSelect: () => null,
  onRemove: () => null,
};

export default translate(CreditCardItem);
